import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Settings02Icon from "@/assets/icons/settings-02.svg?react";
import Paths from "@/constants/paths";
import { useAtomValue } from "jotai";
import { userAtom } from "@/stores/authStore";

export const CollectionHeader = () => {
  const { t } = useTranslation("boLogistics");
  const navigate = useNavigate();
  const user = useAtomValue(userAtom);
  const settingsAvailable = user?.role === "ADMIN" || user?.role === "SUPERADMIN";

  return (
    <div className="flex w-full flex-col justify-between gap-2 md:flex-row">
      <div className="flex w-full flex-col gap-2">
        <h1 className="font-jakarta-sans text-3xl font-semibold">{t("collectionPage.title")}</h1>
        <p>{t("collectionPage.subtitle")}</p>
      </div>
      {settingsAvailable && (
        <button
          onClick={() => navigate(Paths.bo.collectionParamters)}
          className="flex h-fit w-fit flex-row items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-base font-semibold text-gray-800 hover:bg-gray-100"
        >
          <Settings02Icon />
          <span>{t("collectionPage.settings")}</span>
        </button>
      )}
    </div>
  );
};
